// extracted by mini-css-extract-plugin
module.exports = {"mentionAlert":"UserMessages_mentionAlert__u8kwe","blink":"UserMessages_blink__3ezDm"};